export enum ActionTypesEnum {
    DEFAULT = <any>"DEFAULT",
    REFRESH = <any>"REFRESH",
    REFRESH_WIDGET_SIZE = <any>"REFRESH_WIDGET_SIZE",
    REFRESH_CONTROL_BAR = <any>"REFRESH_CONTROL_BAR",
    EDIT = <any>"EDIT",
    SAVE_WIDGET = <any>"SAVE_WIDGET",
    DELETE_WIDGET = <any>"DELETE_WIDGET",
    NEW_CONTROLBAR_ELEMENT = <any>"NEW_CONTROLBAR_ELEMENT",
    UPDATE_SEARCH_REQUEST_DATA = <any>"UPDATE_SEARCH_REQUEST_DATA",
    UPDATE_VIEW = <any>"UPDATE_VIEW",
    DO_SEARCH = <any>"DO_SEARCH",
    FLASH_TIME_SELECTOR = <any>"FLASH_TIME_SELECTOR",
    FLASH_SEARCH_BAR = <any>"FLASH_SEARCH_BAR",
    SERIE_SET_ONLY_ONE = <any>"SERIE_SET_ONLY_ONE",
    FULL_SCREEN_VIEW = <any>"FULL_SCREEN_VIEW",
    FULL_SCREEN_EXIT = <any>"FULL_SCREEN_EXIT",
    SERIE_SET_WIDGET_TYPE=<any>"SERIE_SET_WIDGET_TYPE",
    UPDATE_DYNAMIC_VALUES = <any>"UPDATE_DYNAMIC_VALUES",
    REFRESH_AVAILABLE_FIELDS = <any>"REFRESH_AVAILABLE_FIELDS",
    DUPLICATE = <any>"DUPLICATE",
    LIST_FLOW_TYPES= <any>"LIST_FLOW_TYPES"


}
